import axios from 'axios'

// Get customer details
const get = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/customer/user`)
  return data
}

// Update customer details
const update = async (name, email, phone, newsletter, telegram, traddingview) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/customer/user`, {
    name,
    email,
    phone,
    newsletter,
    telegram,
    traddingview
  })
  return data
}

// Change customer password
const changePass = async (password1, password2) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/customer/user/password`, { password1, password2 })
  return data
}

export {
  get,
  update,
  changePass
}
